<script>
export default {
   name: 'OutsideUSSupplies',
};
</script>

<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="132" height="86" fill="none" viewBox="0 0 132 86">
      <g>
         <path
            fill="#bbc7d5"
            d="M66.375.799a42.5 42.5 0 1 0 0 85 42.5 42.5 0 0 0 0-85M34.713 23.78c1.726 7.06 13.45 13.493 19.746 16.947 2.55 1.397 4.213 2.305 3.947 2.57-.425.426-.86.84-1.285 1.244-2.21 2.104-4.181 3.979-4.027 6.725.186 3.369 3.283 4.378 6.45 5.403 3.064 1 6.204 2.02 6.831 5.222.436 2.216-.398 5.25-1.169 8.075-1.142 4.155-2.157 7.863 1.169 7.863 7.969-2.656 20.177-16.926 21.25-26.562.733-6.604-10.625-10.626-18.594-13.282-2.54-.85-4.01.43-5.26 1.509-.913.797-1.71 1.482-2.709 1.148-2.364-.787-13.28-10.626-7.968-13.282 4.143-2.072 5.057-.908 6.518.967.415.526.866 1.105 1.45 1.69 3.236 1.614 3.517-.702 3.841-3.363.208-1.71.43-3.565 1.472-4.606 2.306-2.306 6.72-4.202 10.774-5.95 3.782-1.626 7.251-3.119 8.388-4.675a37.18 37.18 0 0 1 17.598 37.478 37.188 37.188 0 1 1-68.423-25.116z"
         />
      </g>
      <path fill="#d2ebe4" d="M26.184 61.425H7.763L7.045 75.54l2.512 2.392h14.952l1.675-2.392z" />
      <path
         stroke="#178ece"
         stroke-linecap="round"
         stroke-linejoin="round"
         stroke-width="2"
         d="M7.438 61.611h18.75m.773-7.497-2.766-.003H8.375c-3.182 0-3.75 2.092-3.75 2.813 1.775.246 2.813.468 2.813 2.343v15.47a3.75 3.75 0 0 0 3.75 3.75h11.25a3.75 3.75 0 0 0 3.75-3.75V56.923c0-1.114.673-2.247.738-2.344.07-.111.199-.258.199-.322 0-.065-.018-.144-.164-.144"
      />
      <path fill="#178ece" d="M108.378 71.7h9.824l.383 7.527-1.34 1.276h-7.974l-.893-1.276z" />
      <path
         fill="#fff"
         fill-opacity=".5"
         d="M108.378 71.7h9.824l.383 7.527-1.34 1.276h-7.974l-.893-1.276z"
      />
      <path
         stroke="#178ece"
         stroke-linecap="round"
         stroke-linejoin="round"
         stroke-width="1.5"
         d="M118.375 71.799h-10m-.413-3.999 1.476-.001h8.437c1.697 0 2 1.115 2 1.5-.947.131-1.5.25-1.5 1.25v8.25a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-9.5c0-.594-.359-1.199-.394-1.25-.037-.06-.106-.138-.106-.172s.009-.077.087-.077"
      />
      <path fill="#e2bd4d" d="m106.568 45.461 3.56-7.295h13.208l3.895 7.295z" />
      <path
         fill="#178ece"
         d="m127.924 43.72-7.299-14.16v-7.5h1.875v-1.875h-1.886v-.011l-.855.01h-8.509v1.865h1.875v7.41l-7.301 14.267a1.873 1.873 0 0 0 .765 2.471c.279.156.592.237.911.238h18.75a1.874 1.874 0 0 0 1.674-2.715m-13.125-13.406.201-.403v-7.795l3.75-.045v7.945l.206.403 3.426 6.641h-11.04zM107.5 44.58l2.888-5.646h12.967l2.901 5.625z"
      />
      <path fill="#b6305b" d="m8.16 20.312 2.492-5.106h9.245l2.727 5.106z" />
      <path fill="#fff" fill-opacity=".75" d="m8.16 20.312 2.492-5.106h9.245l2.727 5.106z" />
      <path
         fill="#178ece"
         d="M23.11 19.094 18 9.182v-5.25h1.312V2.619h-1.32v-.008l-.598.007h-5.957v1.306h1.313V9.11l-5.11 9.987a1.312 1.312 0 0 0 1.172 1.896h13.125a1.313 1.313 0 0 0 1.172-1.9m-9.188-9.385.14-.282V3.971l2.625-.031V9.5l.145.283 2.398 4.649h-7.728zm-5.11 9.987 2.022-3.952h9.077l2.03 3.938z"
      />
   </svg>
</template>

<style scoped lang="scss"></style>
